import type { IntlShape } from 'react-intl';
import { z } from 'zod';
import { SharedConfig } from '@_/config/shared-config.ts';
import { errorCommonI18n } from '@_/i18n-common';

export const newPasswordSchema = ({ intl }: { intl: IntlShape }) =>
  z
    .string()
    .min(SharedConfig.password.minLength, intl.formatMessage(errorCommonI18n.passwordTooShort))
    .max(SharedConfig.password.maxLength, intl.formatMessage(errorCommonI18n.passwordTooLong))
    .superRefine((value, ctx) => {
      if (value.length > 1 && value.split('').every(char => char === value[0])) {
        ctx.issues.push({
          code: 'custom',
          input: value,
          message: intl.formatMessage(errorCommonI18n.passwordRepeatingChar)
        });
        return z.NEVER;
      }
    });
